import { render, staticRenderFns } from "./TaskIssueLiuLanStepTwo.vue?vue&type=template&id=e4547a72&"
import script from "./TaskIssueLiuLanStepTwo.vue?vue&type=script&lang=js&"
export * from "./TaskIssueLiuLanStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./TaskIssueLiuLanStepTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports